module.exports = __webpack_public_path__ + "static/img/notStart.87f2065.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activityManage/notStart.svg
// module id = a5D/
// module chunks = 1